import { INTERNAL_NOTE } from 'constants/messageTypes';
import axios from 'axios';
import get from 'lodash/get';
import environment from '../environment';
import { getSessionTokenHeader } from './util';
import { handleError } from 'services/ErrorService/ErrorService';

export const DEFAULT_DEBOUNCE_AMOUNT_FOR_GET_PREDICTION_TEXT = 300;

export const cookConversationMessagesForPredictionAPI = (currentConversation) => {
  return currentConversation.allMessages
    .map((id) => {
      if (currentConversation[id].messageType !== INTERNAL_NOTE) {
        return {
          messageBody: currentConversation[id].messageBody,
          source: currentConversation[id].source,
          direction: currentConversation[id].direction,
        };
      }

      return null;
    })
    .filter(Boolean);
};

export const checkIfPredictionIsTurnedOn = (allowPredictionTextConfig, currentExpertId, currentPartnerId) => {
  const partnerIsInConfig = (allowPredictionTextConfig || []).find((partner) => partner.partnerId === currentPartnerId);
  const expertsConnectedToPartner = get(partnerIsInConfig, 'expertsIds', []);
  const expertIsInConfig = expertsConnectedToPartner.includes(currentExpertId);

  return !!(currentPartnerId && currentExpertId && partnerIsInConfig && expertIsInConfig);
};

export const getPredictionTextViaApi = async (conversationId, businessId, prefix, messages) => {
  const requestParams = {
    conversationId,
    businessId,
    prefix,
    messages,
  };
  try {
    const sessionTokenHeader = await getSessionTokenHeader();
    const requestConfig = { headers: sessionTokenHeader };
    const response = await axios.post(environment.services.autoCompletePredictionMLUrl, requestParams, requestConfig);

    return await response.data;
  } catch (error) {
    handleError({ error, customMessage: 'Prediction API error' });
  }
};
